export default __webpack_public_path__ + "static/media/place_holder_influenceur.17457afc.svg";